var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"threeArea"},[_c('div',{style:({ flex: _vm.flex[0] })},[_vm._t("left")],2),_c('div',{style:({ flex: _vm.flex[1] })},[_vm._t("content")],2),_c('div',{style:({ flex: _vm.flex[2] })},[_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }